/*
 *   Copyright (c) 2021 Novumare Technologies
 *   All rights reserved.
 */
import React, { Component, Suspense } from 'react';
import { Router, Route, Switch, Redirect } from "react-router-dom";

// layouts
import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";

// views without layouts
import Index from "views/Index.js";
import Landing from "views/Landing.js";
import Profile from "views/Profile.js";
import history from './history';


export const Loader = () => (
    <div className="fixed top-0 right-0 h-screen w-screen z-50 flex justify-center items-center">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
    </div>
)

class App extends Component {
    render() {
        return (
            <Suspense fallback={<Loader />}>
                <Router history={history}>
                    <Switch>
                        {/* add routes with layouts */}
                        <Route path="/admin" component={Admin} />
                        <Route path="/auth" component={Auth} />
                        {/* add routes without layouts */}
                        <Route path="/landing" exact component={Landing} />
                        <Route path="/profile" exact component={Profile} />
                        <Route path="/" exact component={Index} />

                        {/* add redirect for first page */}
                        <Redirect from="*" to="/" />
                    </Switch>
                </Router>
            </Suspense>
        )
    }
}
export default App;